import { render, staticRenderFns } from "./ArchiveListPage.vue?vue&type=template&id=0d01cdb4&scoped=true&"
import script from "./ArchiveListPage.vue?vue&type=script&lang=js&"
export * from "./ArchiveListPage.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveListPage.vue?vue&type=style&index=0&id=0d01cdb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d01cdb4",
  null
  
)

export default component.exports